import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { StyledButton as Button } from '../../../styles'
import { LinkIcon, Theme, Panel } from '@pga/pga-component-library'

const { colors } = Theme

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.colors.secondary};
`

export const StyledTitle = styled.div`
  font-family: ${props => props.theme.fonts.body};
  font-size: 28px;
  font-weight: bold;
`

export const StyledTitleInfo = styled.div`
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 35px;
`

export const StyledLink = styled.a`
  color: #0082CE;
  :hover {
    text-decoration: none;
  }
`

export const StyledJobsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const StyledJob = styled(Panel)`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  height: 228px;
  max-height: 229px;
  padding: 26px;
  font-family: ${Theme.fonts.Montserrat};
  transition:0.2s ease-out;
  :hover {
    box-shadow: ${colors.primaryShadow} 0px 10px 10px 0px;
  }
  cursor: pointer;
`

export const StyledTopInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledJobTitle = styled.div`
  margin-bottom: 10px;
  font-family: ${props => props.theme.fonts.body};
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.theme.colors.secondary};
`

export const StyledFacilityInfo = styled.div`
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 400;
  color: ${colors.blueGrey};
  line-height: 15px;
  letter-spacing: -0.47px;
  :last-child {
    margin-bottom: 0;
  }
`

export const StyledBottomInfoWrapper = styled.div`
  display: flex;
  margin-top: auto;
  font-size: 12px;
  font-weight: 500;
`

export const StyledOpenedDate = styled.div`
  color: ${colors.primary};
  letter-spacing: -0.09px;
  font-weight: 400;
`

export const StyledDetailLink = styled(Link)`
  margin-left: auto;
  color: ${colors.lightBlue};
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
`

export const StyledLinkIcon = styled(LinkIcon)`
  padding-left: 4px;
  padding-right: 0;
`

export const StyledButton = styled(Button)`
  font-weight: 400;
  margin-top: 47px;
  width: min-content;
  @media screen and (max-width: 400px) {
    white-space: normal;
  }
`

export const StyledViewAllJobsLink = styled(Link)`
  margin-right: auto;
  margin-left: auto;
`
